import BuyForm from './../BuyForm/BuyForm';
import ContactForm from './../ContactForm/ContactForm';
import Privacy from './../Privacy/Privacy';
import ProfileMethod from './../ProfileMethod/ProfileMethod';

const Popups = () => {
    return (
        <>
            <Privacy></Privacy>
            <BuyForm></BuyForm>
            <ProfileMethod></ProfileMethod>
            <ContactForm></ContactForm>
        </>
    );
};

export default Popups;
